import React, {
  ReactElement,
  useState,
  useRef,
  createContext,
  useEffect,
} from 'react';

import { interactionContext as _interactionContext } from './interactionContext';
import CarouselLayout from './CarouselLayout';

interface CarouselProps {
  children: ReactElement[] | ReactElement | string | null;
}

interface CarouselContext {
  previousIndex: number;
  currentIndex: number;
  animate: boolean;
  hasAnimated: boolean;
  next: () => void;
  prev: () => void;
  goto: (slideNum: number) => void;
}

const CarouselContext = createContext<CarouselContext | undefined>(undefined);

const Carousel = (props: CarouselProps) => {
  const { children } = props as any;

  const [currentIndex, setCurrentIndex] = useState(0);
  const [previousIndex, setPreviousIndex] = useState(0);

  const slideCache = useRef([]);

  // rename to something like shouldAnimateTransition
  const animate = useRef(true);
  const hasAnimated = useRef(false);

  const next = (): void => {
    if (currentIndex < React.Children.count(children) - 1) {
      setPreviousIndex(currentIndex);
      setCurrentIndex(_currentIndex => _currentIndex + 1);

      hasAnimated.current = true;
    }
  };
  const prev = (): void => {
    if (currentIndex >= 1) {
      setPreviousIndex(currentIndex);
      setCurrentIndex(_currentIndex => _currentIndex - 1);
    }
  };
  const goto = (slideNum: number): void => {
    console.log('goto :', slideNum);

    setPreviousIndex(currentIndex);
    setCurrentIndex(slideNum);
  };

  useEffect(() => {
    if (!window.dev()) {
      return;
    }

    if (slideCache.current.length > children.length) {
      const slideCacheIds = slideCache.current.map((s: any) => s.props.id);
      const childrenIds = children.map(c => c.props.id);
      const diff = slideCacheIds.filter(s => !childrenIds.includes(s));
      const removedIndex = slideCacheIds.indexOf(diff[0]);

      if (
        removedIndex < currentIndex ||
        (currentIndex === children.length && removedIndex === children.length)
      ) {
        animate.current = false;
        setCurrentIndex(_currentIndex => _currentIndex - 1);
      }
    }

    slideCache.current = children;
    requestAnimationFrame(() => (animate.current = true));
  }, [children.length]);

  return (
    <CarouselContext.Provider
      value={{
        currentIndex,
        previousIndex,
        animate: animate.current,
        hasAnimated: hasAnimated.current,

        next,
        prev,
        goto,
      }}
    >
      <CarouselLayout>{children}</CarouselLayout>
    </CarouselContext.Provider>
  );
};

export default Carousel;
export { CarouselContext };
